const formatMetopupBalance = (amount) => {
  const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${formattedAmount} MTB`;
};

export default formatMetopupBalance;
